<template>
  <nav v-if="!showMetricsconstant">
    <div class="intro-text">
      <p v-for="(sentence, index) in sentences" :key="index" class="sentence"
        :style="{ animationDelay: `${index * 0.8}s` }">
        {{ sentence }}
      </p>
    </div>
    <ButtonTemplate :button-text="sessionstore.experienceLoaded ? 'Continua' : 'Calcolo score in corso...'"
      @click="showMetrics" class="con-button" :disabled="!sessionstore.experienceLoaded" />
  </nav>
  <nav v-if="showMetricsconstant">
    <ExperienceResults :experienceScore="sessionstore.experienceScore" />
  </nav>
</template>

<script>
// import { ref } from "vue";
// import LoadingBar from '@/components/widgets/LoadingBar.vue';
import ExperienceResults from '@/components/screens/Posizionamento/ExperienceMetrics.vue';
import ButtonTemplate from '@/components/widgets/button.vue';
import { useSessionStore } from '@/stores/sessionStore';

export default {
  setup() {
    const sessionstore = useSessionStore()

    return {
      sessionstore
    };
  },
  name: "ExperienceConfirm",
  components: {
    // LoadingBar,
    ButtonTemplate,
    ExperienceResults
  },
  data() {
    return {
      showMetricsconstant: false,
      sentences: [
        "Siamo al terzo passo. Ci concentriamo sull'esperienza che il tuo brand genera per i consumatori.",
        "La chiamiamo brand experience. Con questo termine intendiamo quegli elementi che completano il prodotto come il servizio clienti, la vendita online, la possibilità di personalizzazione, ecc..",
        "Come per lo storytelling il risultato è compreso tra 100 (la brand experience è al massimo) e 0 (c'è un po' di lavoro da fare)."
      ]
    };
  },

  methods: {
    showMetrics() {
      this.showMetricsconstant = true;
      this.$emit('advance-step');
    },

  },
};
</script>


<style lang="scss" scoped>
nav {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  padding: 4rem;
}

.intro-text {
  width: 100%;
  max-width: 1200px;
  text-align: left;
  margin-bottom: 3rem;
}

.sentence {
  font-size: 2.5rem;
  line-height: 1.4;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 2rem;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.8s ease forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.con-button {
  margin-top: 3rem;
  --button-border-color: #2e4eed;
  --button-text-color: #ffffff;
  --button-background-color: #2e4eed;
  --button-background-hover-color: #1e3ed8;
  --button-border-radius: 0;
  width: 100%;
  max-width: 1200px;
  font-size: 1.5rem;
  padding: 1.5rem;
  opacity: 1;
  transition: opacity 0.3s ease;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

@media (max-width: 768px) {
  nav {
    padding: 2rem 1rem;
  }

  .sentence {
    font-size: 2rem;
  }

  .con-button {
    font-size: 1.25rem;
    padding: 1.25rem;
  }
}
</style>
